// src/pages/NotFoundPage.tsx
import React from 'react';
import { useInRouterContext, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import logo from '../../assets/GreatChildLogo-transparent.webp';
import { brand } from '../Common/ErrorFallback';

const NotFoundPage: React.FC = () => {
  const inRouter = useInRouterContext();
  const navigate = useNavigate();

  const goHome = React.useCallback(() => {
    if (inRouter) {
      // Replace so the user can’t “back” into the 404
      navigate('/', { replace: true });
    } else {
      window.location.replace('/');
    }
  }, [inRouter, navigate]);

  React.useEffect(() => {
    document.title = '404 • Page Not Found';
    // Optional: noindex for this view
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: `linear-gradient(135deg, ${brand.white} 0%, ${brand.yellow} 35%, ${brand.red} 65%, ${brand.blue} 85%, ${brand.green} 100%)`,
        backgroundAttachment: 'fixed',
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div
              className="shadow-lg rounded-4 p-4"
              style={{ background: brand.white, border: `2px solid ${brand.yellow}` }}
            >
              <div className="text-center mb-3">
                <img
                  src={logo}
                  alt="Brand logo"
                  style={{ height: 56, objectFit: 'contain' }}
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                  width={865}
                  height={288}
                />
              </div>

              <div className="text-center">
                <div
                  className="fw-bold mb-2"
                  style={{
                    fontSize: '3rem',
                    lineHeight: 1,
                    color: brand.teal ?? brand.blue, // fallback to blue
                  }}
                  aria-hidden="true"
                >
                  404
                </div>
                <h1 className="h3 mb-2" style={{ color: brand.red }}>
                  Oops! The page you’re looking for doesn’t exist
                </h1>
                <p className="text-muted mb-3">
                  It might have been moved or deleted. Use the button below to head back home.
                </p>
              </div>

              <div className="d-flex justify-content-center">
                <Button
                  style={{ backgroundColor: brand.blue, borderColor: brand.blue }}
                  onClick={goHome}
                >
                  Go home now
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFoundPage;
